import React, { useState, useContext, useEffect, useRef } from 'react'
import QRCode from "react-qr-code";
import QrCodeLink from 'qrcode'
import TableList from '../../components/TableListFiles'
import Sidebar from '../../components/Sidebar'
import { app } from '../../firebase/app';
import HeaderDashboard from '../../components/HeaderDashboard'
import Filter from '../../components/Filter'
import SidebarMobile from '../../components/SidebarMobile';
import Input from '../../components/Input'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ProductContext } from '../../context/products'
import { FileContext } from '../../context/files';
import api from '../../services/api'
import { useReactToPrint } from 'react-to-print';
import Footer from '../../components/Footer';
import Select from '../../components/Select';
import SelectAdd from '../../components/SelectAdd'
import companyBraconi from '../../images/png/companyIconBraconi.PNG'

const Files = () => {
    const contentRef = useRef();

    const reactToPrintFn = useReactToPrint({ contentRef });
    const videoRef = useRef(null);

    var count = 0
    var countMount = 0
    var countEditMount = 0

    const [sidebarState, setSidebarState] = useState(false)

    const [kits, setKits] = useState([])
    const [mount, setMount] = useState([{
        name: ""
    }])
    const { dataProduct } = useContext(ProductContext)
    const { uris, link, linkPdf, id, fileId, sku, setSku, userSelectFiles } = useContext(FileContext)

    const [stateBtn, setStateBtn] = useState()
    const [firebaseFile, setFirebaseFile] = useState()
    const [fileName, setFileName] = useState()
    const [fileNameVideo, setFileNameVideo] = useState()
    const [fileVideo, setFileVideo] = useState()
    const [fileUploadName, setFileUploadName] = useState()
    const [qtdComponent, setQtdComponent] = useState(0)
    const [multipleImages, setMultipleImages] = useState([])
    const [revision, setRevision] = useState()
    const [categorys, setCategorys] = useState([])
    const [selectComponent, setSelectComponent] = useState()
    const [updateData, setUpdateData] = useState(false)
    const [productId, setProductId] = useState()
    const [models, setModels] = useState([])
    const [components, setComponents] = useState()
    const [nameModelSelect, setNameModelSelect] = useState()
    const [nameManual, setNameManual] = useState("")
    const [nameKit, setNameKit] = useState()
    const [quantities, setQuantities] = useState({})
    const [animation, setAnimation] = useState(false)
    const [preview, setPreview] = useState(null); // Estado para armazenar o preview
    const [personalizateFile, setPersonalizateFile] = useState()
    const [personalizateSku, setPersonalizateSku] = useState()
    const [personalizateRevision, setPersonalizateRevision] = useState()

    const [editDataKits, setEditDataKits] = useState([])
    const [editDataMount, setEditDataMount] = useState([])
    const [editRevision, setEditRevision] = useState()
    const [dataSelect] = useState([
        {
            name: "COM FURO"
        },
        {
            name: "SEM FURO"
        }
    ])

    const [maximumAttraction, setMaximumAttraction] = useState()
    const [maximumBall, setMaximumBall] = useState()
    const [instalation, setInstalation] = useState()

    const [editableData, setEditableData] = useState()


    /* FIREBASE */
    const handleFirebase = async (file, id) => {
        const fileName = `${id}-manual.pdf`; // Defina um nome para o arquivo baseado no id ou qualquer outra lógica

        return app.storage().ref(`/fabrica/manuais/${fileName}`).put(file)
            .then(() => {
                console.log(`Arquivo ${fileName} carregado com sucesso`);
                return app.storage().ref(`/fabrica/manuais/${fileName}`).getDownloadURL();

            })
            .then(image => {
                console.log(`URL do arquivo ${fileName}: ${image}`);
                return image; // Retorne a URL
            })
            .catch(error => {
                console.error(`Erro ao carregar o arquivo ${fileName}:`, error);
            });
    };
    const handleFirebaseVideo = async () => {
        if (fileVideo) {
            const fileName = Math.random()

            return app.storage().ref(`/fabrica/videos/${fileName}`).put(fileVideo)
                .then(() => {
                    console.log(`Arquivo ${fileName} carregado com sucesso`);
                    return app.storage().ref(`/fabrica/videos/${fileName}`).getDownloadURL();

                })
                .then(image => {
                    console.log(`URL do arquivo ${fileName}: ${image}`);
                    return image; // Retorne a URL
                })
                .catch(error => {
                    console.error(`Erro ao carregar o arquivo ${fileName}:`, error);
                });
        }
    }

    /* KITS */
    const handleStorage = async () => {

        if (kits.length > 20) {
            return toast.error("Adicione no máximo 20 kits!")
        }

        const isValidPrimary = handleValidateName()
        const isValidSecondary = handleValidateKit()

        if (!isValidPrimary || !isValidSecondary) {
            return false
        }
        handleGenerateReport()

    }
    const handleValidateName = () => {

        if (nameManual == "") {
            toast.error("Informe um nome para o arquivo!", {
                autoClose: 1000,
            })
            return false
        }
        return true

    }
    const handleKit = () => {
        if (kits.length >= 20) {
            return toast.error("Máximo de kits atingido!")
        }
        setKits([...kits, { name: "" }])
    }

    const handleAddEditKit = () => {
        if (editDataKits.length >= 20) {
            return toast.error("Máximo de kits atingido!")
        }
        setEditDataKits([...editDataKits, { name: "" }])
    }
    const handleEditNameKit = (index, value) => {
        kits[index].name = value
        setKits([...kits])
    }
    const handleEditKit = (index, value) => {
        editDataKits[index].name = value
        setEditDataKits([...editDataKits])
    }
    const removeKit = (index) => {
        const copyArray = [...kits]
        copyArray.splice(index, 1)
        console.log(copyArray)
        setKits(copyArray)

    }
    const removeEditKit = (index) => {
        const copyArray = [...editDataKits]
        copyArray.splice(index, 1)
        console.log(copyArray)
        setEditDataKits(copyArray)

    }
    const handleValidateKit = () => {

        var count = 0
        for (let index = 0; index < kits.length; index++) {
            count++
            if (kits[index].name == '') {
                toast.error(`Informe o kit ${count}!`, {
                    autoClose: 1000,
                    type: "error",
                });
            }
        }

        if (kits.length == 0) {
            toast.error("Informe ao menos 1 kit!", {
                autoClose: 1000,
                type: "error",
            });
            return false
        }

        return true

    }

    /* FILES */

    const handlePersonalizateFile = async () => {

        if (!personalizateSku) {
            return toast.error("Informe um SKU!", {
                autoClose: 1500
            })
        }

        if (!personalizateRevision) {
            return toast.error("Informe uma revisão!", {
                autoClose: 1500
            })
        }

        if (!personalizateFile) {
            return toast.error("Informe um arquivo!", {
                autoClose: 1500
            })
        }



        setAnimation(true)
        const uri = await handleFirebase(personalizateFile, Math.random())

        const response = await api.post("panel/storage/file/personalizate", {
            uri: uri,
            revision: personalizateRevision,
            sku: personalizateSku,
        })
        setAnimation(false)
        if (response.status == 200) {
            window.location.href = "/dashboard/files"
        }

    }



    /* COMPONENTS */
    const handleComponent = (item, qtd) => {


        if (!qtd) {
            return toast.error("Informe uma quantidade", {
                autoClose: 1000
            })
        }

        if (kits.length >= 20) {
            return toast.error("Máximo de kits atingido!")
        }


        setKits([...kits, { name: qtd + " " + item }])

    }
    const handleEditComponent = (item, qtd) => {

        if (!qtd) {
            return toast.error("Informe uma quantidade", {
                autoClose: 1000
            })
        }

        if (editDataKits.length >= 20) {
            return toast.error("Máximo de kits atingido!")
        }


        setEditDataKits([...editDataKits, { name: qtd + " " + item }])

    }
    const getComponents = async () => {
        if (nameKit == "") {
            setComponents([])
            return
        }
        const response = await api.get(`panel/get/kit/${nameKit}`)
        if (response.status == 200) {
            setComponents(response.data)
        }
        if (response.status == 404) {
            setComponents([])
        }
    }

    /* FILES */
    const handleFile = (file) => {

        if (file) {
            const supportedFiles = ["application/pdf"]
            const validFile = supportedFiles.includes(file.type)
            if (!validFile) {
                return false
            }
            setFileUploadName(file.name)
            setFirebaseFile(file)
        }

    }
    const handleFileChange = (event) => {
        const file = event.target.files[0]; // Obtém o primeiro arquivo selecionado

        if (file) {
            setFileVideo(file)
            setFileNameVideo(file.name)
            if (file) {
                const url = URL.createObjectURL(file); // Cria uma URL temporária para o vídeo

                const videoElement = document.createElement('video'); // Cria um elemento de vídeo temporário
                videoElement.src = url;

                videoElement.onloadedmetadata = () => {
                    if (videoElement.duration > 120) {
                        alert("O vídeo deve ter no máximo 30 segundos.");
                        URL.revokeObjectURL(url); // Libera a URL do blob para o vídeo rejeitado
                    } else {
                        // Limpa o estado anterior
                        URL.revokeObjectURL(preview?.url); // Libera a URL do blob anterior
                        setPreview({ url, type: file.type }); // Atualiza o preview com o vídeo aceito
                    }
                };
            }
        }
    };
    const handleDelete = async () => {

        const response = await api.delete(`panel/file/${id}`)

        if (response.status == 200) {

            window.location.href = "/dashboard/files"

        }

    }
    const getFile = async () => {
        const response = await api.get(`files/get/info/${id}`)
        if (response.status == 200) {
            setEditDataKits(JSON.parse(response?.data[0].kits))
            setEditDataMount(response?.data[0].mount)
            setEditRevision(response?.data[0].revision)
            setEditableData(response?.data[0])
            setMaximumAttraction(response?.data[0].maximum_attraction)
            setMaximumBall(response?.data[0].maximum_ball)
            setInstalation(response?.data[0].instalation)
        }
    }

    const getNameFile = async (sku) => {
        const response = await api.get(`files/get/name/file/${sku}`)
        if (response.status == 200) {
            console.log(response.data)
            setNameManual(response.data[0].name)
        }
    }


    /* MODELS CARS */
    const getModels = async (e) => {

        if (nameModelSelect == "") {
            setModels([])
            return
        }
        const response = await api.get(`panel/all/models/${nameModelSelect}`)
        if (response.status == 200) {
            setModels(response.data)
        }
        if (response.status == 404) {
            setModels([])
        }
    }
    const handleSelectModel = (name, product_id) => {
        setProductId(product_id)
        setNameModelSelect(name)
        setNameManual(name)
        setModels([])
    }

    /* PRINT MULTIPLE QR CODES */
 const printMultipleQrCodes = async () => {
    await generateMultipleQrCodes();

    const divEl = contentRef.current;
    if (!divEl) return;

    divEl.innerHTML = ''; // Limpa o conteúdo anterior

    Object.keys(quantities).forEach((uri) => {
        const quantity = parseInt(quantities[uri], 10) || 0;
        const imageEntry = multipleImages.find((img) => img.uri === uri);


        for (let i = 0; i < quantity; i++) {
    if (imageEntry) {

        const wrapper = document.createElement("div");
        wrapper.style.width = "85mm";
        wrapper.style.height = "30mm";
        wrapper.style.borderRadius = "5px";
        wrapper.style.display = "flex";
        wrapper.style.alignItems = "center";
        wrapper.style.justifyContent = "space-between";
        wrapper.style.padding = "5mm";
        wrapper.style.boxSizing = "border-box";
        wrapper.style.marginBottom = "8px";
        wrapper.style.fontFamily = "Arial";

        // LEFT SIDE BOX
        const leftBox = document.createElement("div");
        leftBox.style.display = "flex";
        leftBox.style.flexDirection = "column";
        leftBox.style.textAlign = "left";

        // LOGO (Braconi + Inmetro)
        const logo = document.createElement("img");
        logo.src = companyBraconi; // <<<<<< COLOQUE AQUI
        logo.style.width = "38mm"; // Proporcional ao tamanho real
        logo.style.marginBottom = "3px";

        // MANUAL DE INSTALAÇÃO
        const title = document.createElement("p");
        title.textContent = "MANUAL DE INSTALAÇÃO";
        title.style.fontSize = "10px";
        title.style.fontWeight = "bold";
        title.style.margin = "40px 0 2px 0";

        // CÓDIGO
        const codeLine = document.createElement("p");
        codeLine.textContent = `CÓD: ${imageEntry.sku}`;
        codeLine.style.fontSize = "7px";
        codeLine.style.margin = "0";

        // NOME
        const nameLine = document.createElement("p");
        nameLine.textContent = imageEntry.name || "";
        nameLine.style.fontSize = "7px";
        nameLine.style.margin = "0";

        // TEXTO QR
        const qText = document.createElement("p");
        qText.textContent = "APONTE A CÂMERA PARA O QR CODE";
        qText.style.fontSize = "7px";
        qText.style.fontWeight = "bold";
        qText.style.margin = "4px 0 0 0";

        leftBox.appendChild(title);
        leftBox.appendChild(codeLine);
        leftBox.appendChild(nameLine);
        leftBox.appendChild(qText);

        // QR CODE
        const qrImg = document.createElement("img");
        qrImg.src = imageEntry.url;
        qrImg.style.width = "26mm";
        qrImg.style.height = "26mm";
        qrImg.style.objectFit = "contain";

        wrapper.appendChild(leftBox);
        wrapper.appendChild(qrImg);

        divEl.appendChild(wrapper);
    }
}


    });

    reactToPrintFn();
};


    const generateMultipleQrCodes = async () => {
        const newImages = await Promise.all(uris.map(item => {
            const splitName = item.name.split(" ")
            return new Promise((resolve, reject) => {
                QrCodeLink.toDataURL(item.uri, { width: 600, margin: 3 }, (err, url) => {
                    if (err) {
                        reject(err);
                    } else {
                        console.log(`Gerando QR para ${item.uri}: ${url}`);
                        resolve({ url, uri: item.uri, sku: item.sku, name:`${splitName[3] || ''} ${splitName[4] || ''} ${splitName[5] || '' }` });
                    }
                });
            });
        }));


        setMultipleImages(newImages);
    };
    const handleQtdChange = (uri, value) => {

        if (value > 1000) {
            setStateBtn(false)
            return toast.error("Valor máximo atingido", {
                autoClose: 1000,

            })
        }


        setStateBtn(true)

        // Atualiza a quantidade no estado
        setQuantities((prev) => ({
            ...prev,
            [uri]: value,
        }));
    };

    /* MONTAGE INSTRUCTIONS */
    const handleEditMount = (index, value) => {
        mount[index].name = value

    }
    const handleEditDataMount = (index, value) => {
        editDataMount[index].name = value
        setEditDataMount([...editDataMount])

    }
    const handleMount = () => {
        setMount([...mount, { name: "" }])

    }
    const handleAddEditMount = () => {
        setEditDataMount([...editDataMount, { name: "" }])

    }
    const removeMount = (index) => {
        const count = index -= 1
        const copyArray = [...mount]
        copyArray.splice(count, 1)
        console.log(copyArray)
        setMount(copyArray)

    }
    const removeEditMount = (index) => {
        const count = index -= 1
        const copyArray = [...editDataMount]
        copyArray.splice(count, 1)
        console.log(copyArray)
        setEditDataMount(copyArray)

    }

    /* GENERATE MANUAL */
    const handleGenerateReport = async () => {
        setAnimation(true)
        const loadingToastId = toast.loading("Processando o pedido...");
        const videoUrl = await handleFirebaseVideo()

        try {
            const response = await api.post("panel/generate/manual", {
                name: nameManual,
                fileName: nameManual,
                kits: kits,
                mount: mount,
                revision: revision,
                product_id: productId,
                maximumAttraction: maximumAttraction,
                maximumBall: maximumBall,
                instalation: instalation,
                videoUrl: videoUrl,
                sku: sku,
            }, {
                responseType: 'blob', // Indique que você espera um Blob como resposta
            });

            if (response.status == 401) {
                toast.update(loadingToastId, {
                    render: "Manual já existente!",
                    type: "error",
                    isLoading: false,
                    autoClose: 1000
                });
                setAnimation(false)

            }

            if (response.status === 200) {
                toast.update(loadingToastId, {
                    render: "Sucesso!",
                    type: "success",
                    isLoading: false,
                    autoClose: 1000
                });
                setAnimation(false)

                // Criar um Blob a partir da resposta
                const blob = new Blob([response.data], { type: 'application/pdf' });

                const url = URL.createObjectURL(blob);

                // Ação com o URL (abrir em nova aba ou iniciar download)
                const link = document.createElement('a');
                link.href = url;
                link.download = `${nameManual}.pdf`; // Nome do arquivo que será baixado
                document.body.appendChild(link); // Adiciona o link ao DOM
                link.click(); // Simula um clique para iniciar o download
                document.body.removeChild(link); // Remove o link do DOM

                // Enviar o Blob para o Firebase
                const imageUrl = await handleFirebase(blob, productId); // Passe o Blob e o id do produto ou outro identificador

                await api.put("panel/update/file", {
                    uri: imageUrl,
                    file_id: productId,
                })

                setUpdateData(!updateData)
                window.location.href = "/dashboard/files"
                setAnimation(false)

            }
        } catch (error) {
            setAnimation(false)

            console.error('Erro ao gerar PDF:', error);
            toast.update(loadingToastId, {
                render: "Erro ao processar o pedido.",
                type: "error",
                isLoading: false,
                autoClose: 1000
            });
        }
    };
    const handleGenerateReportEdit = async () => {
        setAnimation(true)
        const loadingToastId = toast.loading("Processando o pedido...");
        const videoUrl = await handleFirebaseVideo()

        try {
            const response = await api.post("panel/generate/manual/edit", {
                fileName: `Manual ${nameModelSelect}`,
                kits: editDataKits,
                mount: editDataMount,
                revision: editRevision,
                product_id: productId,
                videoUrl: videoUrl,
                maximumAttraction: maximumAttraction,
                maximumBall: maximumBall,
                instalation: instalation,
                sku: sku

            }, {
                responseType: 'blob', // Indique que você espera um Blob como resposta
            });

            if (response.status === 200) {


                // Criar um Blob a partir da resposta
                const blob = new Blob([response.data], { type: 'application/pdf' });

                const url = URL.createObjectURL(blob);

                // Ação com o URL (abrir em nova aba ou iniciar download)
                const link = document.createElement('a');
                link.href = url;
                link.download = `${nameManual}.pdf`; // Nome do arquivo que será baixado
                document.body.appendChild(link); // Adiciona o link ao DOM
                link.click(); // Simula um clique para iniciar o download
                document.body.removeChild(link); // Remove o link do DOM

                // Enviar o Blob para o Firebase
                const imageUrl = await handleFirebase(blob, productId); // Passe o Blob e o id do produto ou outro identificador

                await api.put("panel/update/file", {
                    uri: imageUrl,
                    file_id: fileId,
                })

                setUpdateData(!updateData)

                toast.update(loadingToastId, {
                    render: "Sucesso!",
                    type: "success",
                    isLoading: false,
                    autoClose: 1000
                });
                setAnimation(false)

                window.location.href = "/dashboard/files"
            }
        } catch (error) {
            setAnimation(false)

            console.error('Erro ao gerar PDF:', error);
            toast.update(loadingToastId, {
                render: "Erro ao processar o pedido.",
                type: "error",
                isLoading: false,
                autoClose: 1000
            });
        }
    };
    /* CATEGORYS */
    const getCategorys = async () => {

        const response = await api.get("panel/get/all/categorys")
        if (response.status == 200) {
            setCategorys(response.data)
        }
    }
    // COPY LINK
    const copyToClipboard = () => {

        if (link) {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(link).then(() => {
                    alert("Link copiado com sucesso!");
                }).catch(err => {
                    console.error("Falha ao copiar o link: ", err);
                });
            } else {
                // Fallback para navegadores antigos
                const textArea = document.createElement("textarea");
                textArea.value = link;
                document.body.appendChild(textArea);
                textArea.select();
                try {
                    document.execCommand('copy');
                    alert('Link copiado!');
                } catch (err) {

                    console.error("Falha ao copiar com o fallback: ", err);
                }
                document.body.removeChild(textArea);
            }
        }

    }
    const getManual = () => {
        window.open(linkPdf, '_blank')
    }
    const updateManual = async () => {

        setAnimation(true)
        const videoUrl = await handleFirebaseVideo()
        const response = await api.put("files/update/manual/", {
            kits: editDataKits,
            mount: editDataMount,
            revision: editRevision,
            video_uri: videoUrl,
            sku: sku,
            maximumAttraction: maximumAttraction,
            maximumBall: maximumBall,
            instalation: instalation,
            id: id
        })

        handleGenerateReportEdit()
        setAnimation(false)


    }

    useEffect(() => {
        getCategorys()
    }, [])
    useEffect(() => {

        getModels()

    }, [nameModelSelect])
    useEffect(() => {

        getComponents()
    }, [nameKit])

    useEffect(() => {
        generateMultipleQrCodes()

    }, [uris])


    return (
        <>
            <ToastContainer />
            <section className='dashboard'>

                <div>
                    <Sidebar />
                    <SidebarMobile state={sidebarState} />
                </div>

                <div className='container_data'>
                    <HeaderDashboard state={sidebarState} onClick={() => setSidebarState(!sidebarState)} name={"Manuais"} />
                    <Filter name={"Adicionar"} onClick={() => setNameManual("")} placeholder={"Pesquisar sku..."} />
                    <div className='container_tablelist'>
                        <TableList update={updateData} />
                    </div>
                    <div style={{ height: "10rem" }}></div>
                </div>

                <div class="modal fade" id="add" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                    <h5 class="modal-title" id="exampleModalLongTitle">Adicionar arquivo</h5>
                                    <button className='btn_have_manual' data-dismiss="modal" data-toggle="modal" data-target="#addPersonalizateFile">Já possui um manual?</button>
                                </div>
                            </div>
                            <div class="modal-body">
                                <p className='textPrimaryModalFile'>Informações do modelo</p>

                                <Input name="Nome do arquivo " value={`MANUAL ${nameManual}`} disabled={true} onChange={(e) => setFileName(e.target.value)} />
                                <Input name="Modelo engate *" onClick={() => setNameModelSelect("")} placeholder="Pesquise por nome ou sku" value={nameModelSelect} onChange={(e) => setNameModelSelect(e.target.value)} />

                                <div className={nameModelSelect == "" || nameModelSelect == undefined ? `models_engate` : `models_engate_scroll`}>
                                    {models?.map(item => {
                                        return (

                                            <div className={models.length == 1 ? `card_model_engate_not_margin` : `card_model_engate`} onClick={() => { handleSelectModel(item.name, item.product_id); setNameModelSelect(""); setSku(item.sku) }}>

                                                <p>{item.name}</p>
                                                <img src={item.product_image} />
                                            </div>

                                        )
                                    })}



                                </div>

                                <Input style={{ textTransform: "uppercase" }} name="Kit *" onClick={() => setNameKit("")} placeholder="Pesquise um kit" value={nameKit} onChange={(e) => setNameKit(e.target.value)} />


                                <div className={nameKit == "" || nameKit == undefined ? `models_engate` : `models_engate_scroll`}>
                                    {components?.map(item => {
                                        return (

                                            <div data-toggle="modal" data-target="#addQtdKit" className={components.length == 1 ? `card_model_engate_not_margin` : `card_model_engate`} onClick={() => { setNameKit(""); setSelectComponent(item.component) }}>
                                                <p>{item.component}</p>
                                            </div>

                                        )
                                    })}



                                </div>


                                <div className={`${kits.length >= 2 ? 'container_kits_scroll' : ''}`}>
                                    {kits?.map((item, index) => {

                                        return (
                                            <div className='container_input_kit'>

                                                <Input name={`Kit ${count += 1}`} value={kits[index].name} onChange={(e) => handleEditNameKit(index, e.target.value)} />
                                                <p onClick={() => removeKit(index)}>X</p>
                                            </div>
                                        )
                                    })}

                                </div>

                                <p className='textSecondaryModalFile' onClick={() => handleKit()}>Adicionar novo Kit +</p>
                                <div className='line_border' style={{ borderBottom: "2.5px solid #dddddd", width: "100%" }}></div>

                                <p className='textPrimaryModalFile'>Informações de montagem</p>

                                <div className={`${mount.length >= 2 ? 'container_kits_scroll' : ''}`}>
                                    {mount?.map((item, index) => {
                                        return (
                                            <div className='container_input_kit'>
                                                <Input style={{ textTransform: "uppercase" }} name={`Instrução ${countMount += 1}`} onChange={(e) => handleEditMount(index, e.target.value)} />
                                                <p onClick={() => removeMount(index)}>X</p>
                                            </div>
                                        )
                                    })}
                                </div>


                                <p className='textSecondaryModalFile' onClick={() => handleMount()}>Adicionar instrução +</p>
                                <div className='line_border' style={{ borderBottom: "2.5px solid #dddddd", width: "100%" }}></div>

                                <p className='textPrimaryModalFile'>Informações de revisão</p>
                                <Input style={{ textTransform: "uppercase" }} name={`Revisão`} onChange={(e) => setRevision(e.target.value)} />
                                <div className='line_border' style={{ borderBottom: "2.5px solid #dddddd", width: "100%" }}></div>


                                <p className='textPrimaryModalFile'>Informações de instalação</p>
                                <Input style={{ textTransform: "uppercase" }} mask={"9999999"} name={`Máximo de Tração`} va placeholder={"ex 450"} onChange={(e) => setMaximumAttraction(e.target.value)} />
                                <Input style={{ textTransform: "uppercase" }} mask={"9999999"} name={`Peso sobre a esfera`} placeholder={"ex 450"} onChange={(e) => setMaximumBall(e.target.value)} />
                                <SelectAdd data={dataSelect} onChange={(e) => setInstalation(e.target.value)} name="Instalação">

                                </SelectAdd>
                                <div className='line_border' style={{ borderBottom: "2.5px solid #dddddd", width: "100%" }}></div>


                                <p className='textPrimaryModalFile'>Fotos & Vídeos</p>
                                <label htmlFor='input_camera'>
                                    <svg width="46" height="47" viewBox="0 0 46 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0246 8.28845H33.9755C36.1461 8.28309 38.2296 9.1416 39.7663 10.6745C41.3031 12.2075 42.1667 14.2889 42.1667 16.4595V30.3806C42.1667 32.5511 41.3031 34.6326 39.7663 36.1655C38.2296 37.6985 36.1461 38.557 33.9755 38.5516H12.0246C9.85401 38.557 7.77048 37.6985 6.23375 36.1655C4.69701 34.6326 3.83337 32.5511 3.83337 30.3806V16.4595C3.83337 14.2889 4.69701 12.2075 6.23375 10.6745C7.77048 9.1416 9.85401 8.28309 12.0246 8.28845ZM33.9755 35.5253C36.7814 35.5261 39.0746 33.2865 39.1404 30.4814V16.4595C39.1293 13.6149 36.8201 11.3147 33.9755 11.3148H12.0246C9.17996 11.3147 6.8708 13.6149 6.85969 16.4595V30.3806C6.8708 33.2252 9.17996 35.5253 12.0246 35.5253H33.9755Z" fill="black" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7886 23.985C14.7886 19.5279 18.4018 15.9148 22.8588 15.9148C27.3158 15.9148 30.929 19.5279 30.929 23.985C30.929 28.442 27.3158 32.0551 22.8588 32.0551C18.4018 32.0551 14.7886 28.442 14.7886 23.985ZM17.815 23.985C17.815 26.7706 20.0732 29.0288 22.8588 29.0288C25.6445 29.0288 27.9027 26.7706 27.9027 23.985C27.9027 21.1993 25.6445 18.9411 22.8588 18.9411C20.0732 18.9411 17.815 21.1993 17.815 23.985Z" fill="black" />
                                        <path d="M30.929 14.8354C30.929 14.3061 31.358 13.8771 31.8873 13.8771H34.0057C34.535 13.8771 34.9641 14.3061 34.9641 14.8354V16.974C34.9641 17.5033 34.535 17.9323 34.0057 17.9323H31.8873C31.358 17.9323 30.929 17.5033 30.929 16.974V14.8354Z" fill="black" />
                                    </svg>


                                </label>
                                <input type="file" onChange={handleFileChange}
                                    name='input_camera' id='input_camera' style={{ display: "none" }} accept="image/*;capture=camera" />

                                {fileNameVideo

                                    ?

                                    <div className='container_data_file'>

                                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M19.1657 6.76064C18.9773 6.70689 18.8053 6.60688 18.6654 6.46971C18.5255 6.33253 18.4221 6.16255 18.3647 5.97522C18.0457 4.89402 17.5107 3.88878 16.7919 3.02032C16.0732 2.15187 15.1858 1.43826 14.1833 0.922683C13.1809 0.407104 12.0842 0.100273 10.9598 0.0207577C9.83529 -0.0587573 8.70638 0.0906966 7.64134 0.460076C6.5763 0.829454 5.59727 1.41108 4.7635 2.16975C3.92973 2.92842 3.25856 3.84837 2.7906 4.87393C2.32263 5.89948 2.0676 7.00932 2.04095 8.13628C2.01429 9.26324 2.21656 10.3839 2.63552 11.4304C2.73176 11.6507 2.75248 11.8966 2.69446 12.1298C2.63643 12.363 2.50291 12.5705 2.31468 12.72C1.48523 13.3356 0.837648 14.164 0.440467 15.1176C0.0432851 16.0711 -0.0887159 17.1143 0.0584343 18.1367C0.288073 19.5188 1.00565 20.7729 2.08092 21.6712C3.15618 22.5695 4.51788 23.0525 5.91885 23.0325H11.4574C11.7337 23.0325 11.9986 22.9228 12.194 22.7274C12.3893 22.5321 12.4991 22.2671 12.4991 21.9908C12.4991 21.7146 12.3893 21.4496 12.194 21.2543C11.9986 21.0589 11.7337 20.9492 11.4574 20.9492H5.91885C5.01914 20.971 4.14138 20.6698 3.44464 20.1001C2.74791 19.5305 2.2783 18.7301 2.12093 17.844C2.02114 17.1927 2.10202 16.5264 2.35476 15.9179C2.6075 15.3094 3.0224 14.7819 3.55427 14.3929C4.11293 13.9754 4.51706 13.3841 4.70316 12.7119C4.88926 12.0397 4.84678 11.3248 4.58239 10.6794C4.05963 9.29887 4.03275 7.77962 4.50635 6.38147C4.88468 5.28624 5.56217 4.31885 6.46206 3.58888C7.36196 2.85891 8.4483 2.39554 9.59802 2.25127C9.8647 2.21693 10.1333 2.19954 10.4022 2.19918C11.7491 2.19474 13.0612 2.62671 14.1421 3.43042C15.223 4.23413 16.0145 5.36634 16.398 6.65752C16.5477 7.14957 16.8175 7.59665 17.183 7.95851C17.5485 8.32037 17.9982 8.58564 18.4918 8.73043C19.6996 9.08764 20.7694 9.8053 21.5581 10.7873C22.3468 11.7694 22.8167 12.9689 22.9048 14.2253C22.993 15.4817 22.6952 16.7351 22.0513 17.8176C21.4075 18.9002 20.4483 19.7602 19.3022 20.2825C19.1326 20.3694 18.9908 20.5021 18.893 20.6657C18.7952 20.8292 18.7453 21.017 18.7491 21.2075V21.2075C18.747 21.3799 18.7883 21.55 18.8692 21.7022C18.95 21.8545 19.0678 21.984 19.2117 22.0789C19.3556 22.1738 19.5211 22.231 19.6929 22.2452C19.8647 22.2595 20.0373 22.2304 20.1949 22.1606C24.5011 20.0908 26.8407 14.6461 23.1949 9.38564C22.191 8.07618 20.7691 7.14983 19.1657 6.76064V6.76064Z" fill="black" />
                                            <path d="M19.486 16.4773C19.6813 16.282 19.791 16.0171 19.791 15.7409C19.791 15.4647 19.6813 15.1998 19.486 15.0044L17.8339 13.3523C17.2479 12.7665 16.4532 12.4374 15.6246 12.4374C14.7959 12.4374 14.0012 12.7665 13.4152 13.3523L11.7631 15.0044C11.5734 15.2009 11.4684 15.464 11.4707 15.7371C11.4731 16.0102 11.5827 16.2715 11.7758 16.4646C11.9689 16.6578 12.2302 16.7673 12.5033 16.7697C12.7764 16.7721 13.0396 16.6671 13.236 16.4773L14.5829 15.1305V23.0325C14.5829 23.3088 14.6926 23.5738 14.888 23.7691C15.0833 23.9645 15.3483 24.0742 15.6246 24.0742C15.9008 24.0742 16.1658 23.9645 16.3611 23.7691C16.5565 23.5738 16.6662 23.3088 16.6662 23.0325V15.1305L18.0131 16.4773C18.2084 16.6726 18.4733 16.7823 18.7496 16.7823C19.0258 16.7823 19.2907 16.6726 19.486 16.4773Z" fill="black" />
                                        </svg>

                                        <p>{fileNameVideo}</p>


                                    </div>
                                    :
                                    <></>
                                }



                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-primary" disabled={animation} onClick={() => handleStorage()}>{animation == true ? "Processando..." : "Salvar"}</button>
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="editManual" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                    <h5 class="modal-title" id="exampleModalLongTitle">Editar manual</h5>
                                </div>
                            </div>
                            <div class="modal-body">
                                <Input name="Nome do arquivo *" value={`MANUAL ${nameManual}`} disabled={true} onChange={(e) => setFileName(e.target.value)} />
                                <Input name="Modelo engate *" onClick={() => setNameModelSelect("")} placeholder="Pesquise um modelo" value={nameModelSelect} onChange={(e) => setNameModelSelect(e.target.value)} />

                                <div className={nameModelSelect == "" || nameModelSelect == undefined ? `models_engate` : `models_engate_scroll`}>
                                    {models?.map(item => {
                                        return (

                                            <div className={models.length == 1 ? `card_model_engate_not_margin` : `card_model_engate`} onClick={() => { handleSelectModel(item.name, item.product_id); setNameModelSelect(""); setSku(item.sku) }}>

                                                <p>{item.name}</p>
                                                <img src={item.product_image} />
                                            </div>

                                        )
                                    })}



                                </div>

                                <Input style={{ textTransform: "uppercase" }} name="Kit *" onClick={() => setNameKit("")} placeholder="Pesquise um kit" value={nameKit} onChange={(e) => setNameKit(e.target.value)} />


                                <div className={nameKit == "" || nameKit == undefined ? `models_engate` : `models_engate_scroll`}>
                                    {components?.map(item => {
                                        return (

                                            <div data-toggle="modal" data-target="#addEditQtdKit" className={components.length == 1 ? `card_model_engate_not_margin` : `card_model_engate`} onClick={() => { setNameKit(""); setSelectComponent(item.component) }}>
                                                <p>{item.component}</p>
                                            </div>

                                        )
                                    })}



                                </div>


                                <div className={`${editDataKits.length >= 2 ? 'container_kits_scroll' : ''}`}>
                                    {editDataKits?.map((item, index) => {
                                        return (

                                            <div className='container_input_kit'>
                                                <Input name={`Kit ${count += 1}`} value={item.name} onChange={(e) => handleEditKit(index, e.target.value)} />
                                                <p onClick={() => removeEditKit(index)}>X</p>
                                            </div>
                                        )
                                    })}

                                </div>

                                <p className='textSecondaryModalFile' onClick={() => handleAddEditKit()}>Adicionar novo Kit +</p>


                                <p className='textPrimaryModalFile'>Informações de montagem</p>

                                <div className={`${editDataMount.length >= 2 ? 'container_kits_scroll' : ''}`}>
                                    {editDataMount?.map((item, index) => {
                                        return (
                                            <div className='container_input_kit'>
                                                <Input style={{ textTransform: "uppercase" }} value={item.name} name={`Instrução ${countEditMount += 1}`} onChange={(e) => handleEditDataMount(index, e.target.value)} />
                                                <p onClick={() => removeEditMount(index)}>X</p>
                                            </div>
                                        )
                                    })}
                                </div>


                                <p className='textSecondaryModalFile' onClick={() => handleAddEditMount()}>Adicionar instrução +</p>

                                <p className='textPrimaryModalFile'>Informações de revisão</p>
                                <Input style={{ textTransform: "uppercase" }} name={`Revisão`} value={editRevision} onChange={(e) => setEditRevision(e.target.value)} />


                                <p className='textPrimaryModalFile'>Informações de instalação</p>
                                <Input style={{ textTransform: "uppercase" }} mask={"9999999"} value={maximumAttraction ? maximumAttraction : ""} name={`Máximo de Tração`} placeholder={"ex 450"} onChange={(e) => setMaximumAttraction(e.target.value)} />
                                <Input style={{ textTransform: "uppercase" }} mask={"9999999"} value={maximumBall ? maximumBall : ""} name={`Peso sobre a esfera`} placeholder={"ex 450"} onChange={(e) => setMaximumBall(e.target.value)} />
                                <Select data={dataSelect} value={instalation ? instalation : ""} onChange={(e) => setInstalation(e.target.value)} name="Instalação">

                                </Select>
                                <div className='line_border' style={{ borderBottom: "2.5px solid #dddddd", width: "100%" }}></div>




                                <p className='textPrimaryModalFile'>Fotos & Vídeos</p>
                                <label htmlFor='input_camera'>
                                    <svg width="46" height="47" viewBox="0 0 46 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0246 8.28845H33.9755C36.1461 8.28309 38.2296 9.1416 39.7663 10.6745C41.3031 12.2075 42.1667 14.2889 42.1667 16.4595V30.3806C42.1667 32.5511 41.3031 34.6326 39.7663 36.1655C38.2296 37.6985 36.1461 38.557 33.9755 38.5516H12.0246C9.85401 38.557 7.77048 37.6985 6.23375 36.1655C4.69701 34.6326 3.83337 32.5511 3.83337 30.3806V16.4595C3.83337 14.2889 4.69701 12.2075 6.23375 10.6745C7.77048 9.1416 9.85401 8.28309 12.0246 8.28845ZM33.9755 35.5253C36.7814 35.5261 39.0746 33.2865 39.1404 30.4814V16.4595C39.1293 13.6149 36.8201 11.3147 33.9755 11.3148H12.0246C9.17996 11.3147 6.8708 13.6149 6.85969 16.4595V30.3806C6.8708 33.2252 9.17996 35.5253 12.0246 35.5253H33.9755Z" fill="black" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7886 23.985C14.7886 19.5279 18.4018 15.9148 22.8588 15.9148C27.3158 15.9148 30.929 19.5279 30.929 23.985C30.929 28.442 27.3158 32.0551 22.8588 32.0551C18.4018 32.0551 14.7886 28.442 14.7886 23.985ZM17.815 23.985C17.815 26.7706 20.0732 29.0288 22.8588 29.0288C25.6445 29.0288 27.9027 26.7706 27.9027 23.985C27.9027 21.1993 25.6445 18.9411 22.8588 18.9411C20.0732 18.9411 17.815 21.1993 17.815 23.985Z" fill="black" />
                                        <path d="M30.929 14.8354C30.929 14.3061 31.358 13.8771 31.8873 13.8771H34.0057C34.535 13.8771 34.9641 14.3061 34.9641 14.8354V16.974C34.9641 17.5033 34.535 17.9323 34.0057 17.9323H31.8873C31.358 17.9323 30.929 17.5033 30.929 16.974V14.8354Z" fill="black" />
                                    </svg>


                                </label>

                                <input type="file" onChange={handleFileChange}
                                    name='input_camera' id='input_camera' style={{ display: "none" }} accept="image/*;capture=camera" />

                                {fileNameVideo

                                    ?

                                    <div className='container_data_file'>

                                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M19.1657 6.76064C18.9773 6.70689 18.8053 6.60688 18.6654 6.46971C18.5255 6.33253 18.4221 6.16255 18.3647 5.97522C18.0457 4.89402 17.5107 3.88878 16.7919 3.02032C16.0732 2.15187 15.1858 1.43826 14.1833 0.922683C13.1809 0.407104 12.0842 0.100273 10.9598 0.0207577C9.83529 -0.0587573 8.70638 0.0906966 7.64134 0.460076C6.5763 0.829454 5.59727 1.41108 4.7635 2.16975C3.92973 2.92842 3.25856 3.84837 2.7906 4.87393C2.32263 5.89948 2.0676 7.00932 2.04095 8.13628C2.01429 9.26324 2.21656 10.3839 2.63552 11.4304C2.73176 11.6507 2.75248 11.8966 2.69446 12.1298C2.63643 12.363 2.50291 12.5705 2.31468 12.72C1.48523 13.3356 0.837648 14.164 0.440467 15.1176C0.0432851 16.0711 -0.0887159 17.1143 0.0584343 18.1367C0.288073 19.5188 1.00565 20.7729 2.08092 21.6712C3.15618 22.5695 4.51788 23.0525 5.91885 23.0325H11.4574C11.7337 23.0325 11.9986 22.9228 12.194 22.7274C12.3893 22.5321 12.4991 22.2671 12.4991 21.9908C12.4991 21.7146 12.3893 21.4496 12.194 21.2543C11.9986 21.0589 11.7337 20.9492 11.4574 20.9492H5.91885C5.01914 20.971 4.14138 20.6698 3.44464 20.1001C2.74791 19.5305 2.2783 18.7301 2.12093 17.844C2.02114 17.1927 2.10202 16.5264 2.35476 15.9179C2.6075 15.3094 3.0224 14.7819 3.55427 14.3929C4.11293 13.9754 4.51706 13.3841 4.70316 12.7119C4.88926 12.0397 4.84678 11.3248 4.58239 10.6794C4.05963 9.29887 4.03275 7.77962 4.50635 6.38147C4.88468 5.28624 5.56217 4.31885 6.46206 3.58888C7.36196 2.85891 8.4483 2.39554 9.59802 2.25127C9.8647 2.21693 10.1333 2.19954 10.4022 2.19918C11.7491 2.19474 13.0612 2.62671 14.1421 3.43042C15.223 4.23413 16.0145 5.36634 16.398 6.65752C16.5477 7.14957 16.8175 7.59665 17.183 7.95851C17.5485 8.32037 17.9982 8.58564 18.4918 8.73043C19.6996 9.08764 20.7694 9.8053 21.5581 10.7873C22.3468 11.7694 22.8167 12.9689 22.9048 14.2253C22.993 15.4817 22.6952 16.7351 22.0513 17.8176C21.4075 18.9002 20.4483 19.7602 19.3022 20.2825C19.1326 20.3694 18.9908 20.5021 18.893 20.6657C18.7952 20.8292 18.7453 21.017 18.7491 21.2075V21.2075C18.747 21.3799 18.7883 21.55 18.8692 21.7022C18.95 21.8545 19.0678 21.984 19.2117 22.0789C19.3556 22.1738 19.5211 22.231 19.6929 22.2452C19.8647 22.2595 20.0373 22.2304 20.1949 22.1606C24.5011 20.0908 26.8407 14.6461 23.1949 9.38564C22.191 8.07618 20.7691 7.14983 19.1657 6.76064V6.76064Z" fill="black" />
                                            <path d="M19.486 16.4773C19.6813 16.282 19.791 16.0171 19.791 15.7409C19.791 15.4647 19.6813 15.1998 19.486 15.0044L17.8339 13.3523C17.2479 12.7665 16.4532 12.4374 15.6246 12.4374C14.7959 12.4374 14.0012 12.7665 13.4152 13.3523L11.7631 15.0044C11.5734 15.2009 11.4684 15.464 11.4707 15.7371C11.4731 16.0102 11.5827 16.2715 11.7758 16.4646C11.9689 16.6578 12.2302 16.7673 12.5033 16.7697C12.7764 16.7721 13.0396 16.6671 13.236 16.4773L14.5829 15.1305V23.0325C14.5829 23.3088 14.6926 23.5738 14.888 23.7691C15.0833 23.9645 15.3483 24.0742 15.6246 24.0742C15.9008 24.0742 16.1658 23.9645 16.3611 23.7691C16.5565 23.5738 16.6662 23.3088 16.6662 23.0325V15.1305L18.0131 16.4773C18.2084 16.6726 18.4733 16.7823 18.7496 16.7823C19.0258 16.7823 19.2907 16.6726 19.486 16.4773Z" fill="black" />
                                        </svg>

                                        <p>{fileNameVideo}</p>


                                    </div>
                                    :
                                    <></>
                                }



                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-primary" disabled={animation} onClick={() => updateManual()}>{animation == true ? "Alterando..." : "Editar"}</button>
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="edit" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLongTitle">Editar arquivo</h5>
                            </div>
                            <div class="modal-body">
                                <Input name="Produto *" value={dataProduct?.name} />
                                <input type='file' onChange={(e) => handleFile(e.target.files[0])} style={{ display: "none" }} name='file_input' id='file_input' />
                                <label htmlFor='file_input'>
                                    <svg width="189" height="25" viewBox="0 0 189 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M43.008 7.88V14.968C43.008 15.8107 43.2267 16.4453 43.664 16.872C44.112 17.2987 44.7307 17.512 45.52 17.512C46.32 17.512 46.9387 17.2987 47.376 16.872C47.824 16.4453 48.048 15.8107 48.048 14.968V7.88H49.872V14.936C49.872 15.8427 49.6747 16.6107 49.28 17.24C48.8853 17.8693 48.3573 18.3387 47.696 18.648C47.0347 18.9573 46.304 19.112 45.504 19.112C44.704 19.112 43.9733 18.9573 43.312 18.648C42.6613 18.3387 42.144 17.8693 41.76 17.24C41.376 16.6107 41.184 15.8427 41.184 14.936V7.88H43.008ZM54.0709 11.48C54.3802 11.0747 54.8015 10.7333 55.3349 10.456C55.8682 10.1787 56.4709 10.04 57.1429 10.04C57.9109 10.04 58.6095 10.232 59.2389 10.616C59.8789 10.9893 60.3802 11.5173 60.7429 12.2C61.1055 12.8827 61.2869 13.6667 61.2869 14.552C61.2869 15.4373 61.1055 16.232 60.7429 16.936C60.3802 17.6293 59.8789 18.1733 59.2389 18.568C58.6095 18.952 57.9109 19.144 57.1429 19.144C56.4709 19.144 55.8735 19.0107 55.3509 18.744C54.8282 18.4667 54.4015 18.1253 54.0709 17.72V23.192H52.2469V10.184H54.0709V11.48ZM59.4309 14.552C59.4309 13.944 59.3029 13.4213 59.0469 12.984C58.8015 12.536 58.4709 12.2 58.0549 11.976C57.6495 11.7413 57.2122 11.624 56.7429 11.624C56.2842 11.624 55.8469 11.7413 55.4309 11.976C55.0255 12.2107 54.6949 12.552 54.4389 13C54.1935 13.448 54.0709 13.976 54.0709 14.584C54.0709 15.192 54.1935 15.7253 54.4389 16.184C54.6949 16.632 55.0255 16.9733 55.4309 17.208C55.8469 17.4427 56.2842 17.56 56.7429 17.56C57.2122 17.56 57.6495 17.4427 58.0549 17.208C58.4709 16.9627 58.8015 16.6107 59.0469 16.152C59.3029 15.6933 59.4309 15.16 59.4309 14.552ZM64.9146 7.16V19H63.0906V7.16H64.9146ZM71.1334 19.144C70.3014 19.144 69.5494 18.9573 68.8774 18.584C68.2054 18.2 67.6774 17.6667 67.2934 16.984C66.9094 16.2907 66.7174 15.4907 66.7174 14.584C66.7174 13.688 66.9147 12.8933 67.3094 12.2C67.704 11.5067 68.2427 10.9733 68.9254 10.6C69.608 10.2267 70.3707 10.04 71.2134 10.04C72.056 10.04 72.8187 10.2267 73.5014 10.6C74.184 10.9733 74.7227 11.5067 75.1174 12.2C75.512 12.8933 75.7094 13.688 75.7094 14.584C75.7094 15.48 75.5067 16.2747 75.1014 16.968C74.696 17.6613 74.1414 18.2 73.4374 18.584C72.744 18.9573 71.976 19.144 71.1334 19.144ZM71.1334 17.56C71.6027 17.56 72.04 17.448 72.4454 17.224C72.8614 17 73.1974 16.664 73.4534 16.216C73.7094 15.768 73.8374 15.224 73.8374 14.584C73.8374 13.944 73.7147 13.4053 73.4694 12.968C73.224 12.52 72.8987 12.184 72.4934 11.96C72.088 11.736 71.6507 11.624 71.1814 11.624C70.712 11.624 70.2747 11.736 69.8694 11.96C69.4747 12.184 69.16 12.52 68.9254 12.968C68.6907 13.4053 68.5734 13.944 68.5734 14.584C68.5734 15.5333 68.8134 16.2693 69.2934 16.792C69.784 17.304 70.3974 17.56 71.1334 17.56ZM76.9045 14.552C76.9045 13.6667 77.0858 12.8827 77.4485 12.2C77.8218 11.5173 78.3232 10.9893 78.9525 10.616C79.5925 10.232 80.2965 10.04 81.0645 10.04C81.7578 10.04 82.3605 10.1787 82.8725 10.456C83.3952 10.7227 83.8112 11.0587 84.1205 11.464V10.184H85.9605V19H84.1205V17.688C83.8112 18.104 83.3898 18.4507 82.8565 18.728C82.3232 19.0053 81.7152 19.144 81.0325 19.144C80.2752 19.144 79.5818 18.952 78.9525 18.568C78.3232 18.1733 77.8218 17.6293 77.4485 16.936C77.0858 16.232 76.9045 15.4373 76.9045 14.552ZM84.1205 14.584C84.1205 13.976 83.9925 13.448 83.7365 13C83.4912 12.552 83.1658 12.2107 82.7605 11.976C82.3552 11.7413 81.9178 11.624 81.4485 11.624C80.9792 11.624 80.5418 11.7413 80.1365 11.976C79.7312 12.2 79.4005 12.536 79.1445 12.984C78.8992 13.4213 78.7765 13.944 78.7765 14.552C78.7765 15.16 78.8992 15.6933 79.1445 16.152C79.4005 16.6107 79.7312 16.9627 80.1365 17.208C80.5525 17.4427 80.9898 17.56 81.4485 17.56C81.9178 17.56 82.3552 17.4427 82.7605 17.208C83.1658 16.9733 83.4912 16.632 83.7365 16.184C83.9925 15.7253 84.1205 15.192 84.1205 14.584ZM87.7483 14.552C87.7483 13.6667 87.9296 12.8827 88.2923 12.2C88.6656 11.5173 89.1669 10.9893 89.7963 10.616C90.4363 10.232 91.1456 10.04 91.9243 10.04C92.5003 10.04 93.0656 10.168 93.6203 10.424C94.1856 10.6693 94.6336 11 94.9643 11.416V7.16H96.8043V19H94.9643V17.672C94.6656 18.0987 94.2496 18.4507 93.7163 18.728C93.1936 19.0053 92.5909 19.144 91.9083 19.144C91.1403 19.144 90.4363 18.952 89.7963 18.568C89.1669 18.1733 88.6656 17.6293 88.2923 16.936C87.9296 16.232 87.7483 15.4373 87.7483 14.552ZM94.9643 14.584C94.9643 13.976 94.8363 13.448 94.5803 13C94.3349 12.552 94.0096 12.2107 93.6043 11.976C93.1989 11.7413 92.7616 11.624 92.2923 11.624C91.8229 11.624 91.3856 11.7413 90.9803 11.976C90.5749 12.2 90.2443 12.536 89.9883 12.984C89.7429 13.4213 89.6203 13.944 89.6203 14.552C89.6203 15.16 89.7429 15.6933 89.9883 16.152C90.2443 16.6107 90.5749 16.9627 90.9803 17.208C91.3963 17.4427 91.8336 17.56 92.2923 17.56C92.7616 17.56 93.1989 17.4427 93.6043 17.208C94.0096 16.9733 94.3349 16.632 94.5803 16.184C94.8363 15.7253 94.9643 15.192 94.9643 14.584ZM102.748 14.552C102.748 13.6667 102.93 12.8827 103.292 12.2C103.666 11.5173 104.167 10.9893 104.796 10.616C105.436 10.232 106.146 10.04 106.924 10.04C107.5 10.04 108.066 10.168 108.62 10.424C109.186 10.6693 109.634 11 109.964 11.416V7.16H111.804V19H109.964V17.672C109.666 18.0987 109.25 18.4507 108.716 18.728C108.194 19.0053 107.591 19.144 106.908 19.144C106.14 19.144 105.436 18.952 104.796 18.568C104.167 18.1733 103.666 17.6293 103.292 16.936C102.93 16.232 102.748 15.4373 102.748 14.552ZM109.964 14.584C109.964 13.976 109.836 13.448 109.58 13C109.335 12.552 109.01 12.2107 108.604 11.976C108.199 11.7413 107.762 11.624 107.292 11.624C106.823 11.624 106.386 11.7413 105.98 11.976C105.575 12.2 105.244 12.536 104.988 12.984C104.743 13.4213 104.62 13.944 104.62 14.552C104.62 15.16 104.743 15.6933 104.988 16.152C105.244 16.6107 105.575 16.9627 105.98 17.208C106.396 17.4427 106.834 17.56 107.292 17.56C107.762 17.56 108.199 17.4427 108.604 17.208C109.01 16.9733 109.335 16.632 109.58 16.184C109.836 15.7253 109.964 15.192 109.964 14.584ZM122.28 14.376C122.28 14.7067 122.259 15.0053 122.216 15.272H115.48C115.533 15.976 115.795 16.5413 116.264 16.968C116.733 17.3947 117.309 17.608 117.992 17.608C118.973 17.608 119.667 17.1973 120.072 16.376H122.04C121.773 17.1867 121.288 17.8533 120.584 18.376C119.891 18.888 119.027 19.144 117.992 19.144C117.149 19.144 116.392 18.9573 115.72 18.584C115.059 18.2 114.536 17.6667 114.152 16.984C113.779 16.2907 113.592 15.4907 113.592 14.584C113.592 13.6773 113.773 12.8827 114.136 12.2C114.509 11.5067 115.027 10.9733 115.688 10.6C116.36 10.2267 117.128 10.04 117.992 10.04C118.824 10.04 119.565 10.2213 120.216 10.584C120.867 10.9467 121.373 11.4587 121.736 12.12C122.099 12.7707 122.28 13.5227 122.28 14.376ZM120.376 13.8C120.365 13.128 120.125 12.5893 119.656 12.184C119.187 11.7787 118.605 11.576 117.912 11.576C117.283 11.576 116.744 11.7787 116.296 12.184C115.848 12.5787 115.581 13.1173 115.496 13.8H120.376ZM127.623 14.552C127.623 13.6667 127.805 12.8827 128.167 12.2C128.541 11.5173 129.042 10.9893 129.671 10.616C130.311 10.232 131.015 10.04 131.783 10.04C132.477 10.04 133.079 10.1787 133.591 10.456C134.114 10.7227 134.53 11.0587 134.839 11.464V10.184H136.679V19H134.839V17.688C134.53 18.104 134.109 18.4507 133.575 18.728C133.042 19.0053 132.434 19.144 131.751 19.144C130.994 19.144 130.301 18.952 129.671 18.568C129.042 18.1733 128.541 17.6293 128.167 16.936C127.805 16.232 127.623 15.4373 127.623 14.552ZM134.839 14.584C134.839 13.976 134.711 13.448 134.455 13C134.21 12.552 133.885 12.2107 133.479 11.976C133.074 11.7413 132.637 11.624 132.167 11.624C131.698 11.624 131.261 11.7413 130.855 11.976C130.45 12.2 130.119 12.536 129.863 12.984C129.618 13.4213 129.495 13.944 129.495 14.552C129.495 15.16 129.618 15.6933 129.863 16.152C130.119 16.6107 130.45 16.9627 130.855 17.208C131.271 17.4427 131.709 17.56 132.167 17.56C132.637 17.56 133.074 17.4427 133.479 17.208C133.885 16.9733 134.21 16.632 134.455 16.184C134.711 15.7253 134.839 15.192 134.839 14.584ZM140.899 11.464C141.166 11.016 141.518 10.6693 141.955 10.424C142.403 10.168 142.931 10.04 143.539 10.04V11.928H143.075C142.36 11.928 141.816 12.1093 141.443 12.472C141.08 12.8347 140.899 13.464 140.899 14.36V19H139.075V10.184H140.899V11.464ZM144.608 14.552C144.608 13.6667 144.789 12.8827 145.152 12.2C145.525 11.5173 146.026 10.9893 146.656 10.616C147.296 10.232 148.005 10.04 148.784 10.04C149.466 10.04 150.069 10.1787 150.592 10.456C151.125 10.7333 151.536 11.0693 151.824 11.464V10.184H153.664V23.192H151.824V17.72C151.536 18.1147 151.12 18.4507 150.576 18.728C150.032 19.0053 149.413 19.144 148.72 19.144C147.962 19.144 147.269 18.952 146.64 18.568C146.021 18.1733 145.525 17.6293 145.152 16.936C144.789 16.232 144.608 15.4373 144.608 14.552ZM151.824 14.584C151.824 13.976 151.696 13.448 151.44 13C151.194 12.552 150.869 12.2107 150.464 11.976C150.058 11.7413 149.621 11.624 149.152 11.624C148.682 11.624 148.245 11.7413 147.84 11.976C147.434 12.2 147.104 12.536 146.848 12.984C146.602 13.4213 146.48 13.944 146.48 14.552C146.48 15.16 146.602 15.6933 146.848 16.152C147.104 16.6107 147.434 16.9627 147.84 17.208C148.256 17.4427 148.693 17.56 149.152 17.56C149.621 17.56 150.058 17.4427 150.464 17.208C150.869 16.9733 151.194 16.632 151.44 16.184C151.696 15.7253 151.824 15.192 151.824 14.584ZM164.043 10.184V19H162.219V17.96C161.931 18.3227 161.553 18.6107 161.083 18.824C160.625 19.0267 160.134 19.128 159.611 19.128C158.918 19.128 158.294 18.984 157.739 18.696C157.195 18.408 156.763 17.9813 156.443 17.416C156.134 16.8507 155.979 16.168 155.979 15.368V10.184H157.787V15.096C157.787 15.8853 157.985 16.4933 158.379 16.92C158.774 17.336 159.313 17.544 159.995 17.544C160.678 17.544 161.217 17.336 161.611 16.92C162.017 16.4933 162.219 15.8853 162.219 15.096V10.184H164.043ZM167.378 9.016C167.047 9.016 166.77 8.904 166.546 8.68C166.322 8.456 166.21 8.17867 166.21 7.848C166.21 7.51733 166.322 7.24 166.546 7.016C166.77 6.792 167.047 6.68 167.378 6.68C167.698 6.68 167.97 6.792 168.194 7.016C168.418 7.24 168.53 7.51733 168.53 7.848C168.53 8.17867 168.418 8.456 168.194 8.68C167.97 8.904 167.698 9.016 167.378 9.016ZM168.274 10.184V19H166.45V10.184H168.274ZM174.077 17.368L176.573 10.184H178.509L175.149 19H172.973L169.629 10.184H171.581L174.077 17.368ZM183.712 19.144C182.88 19.144 182.128 18.9573 181.456 18.584C180.784 18.2 180.256 17.6667 179.872 16.984C179.488 16.2907 179.296 15.4907 179.296 14.584C179.296 13.688 179.493 12.8933 179.888 12.2C180.282 11.5067 180.821 10.9733 181.504 10.6C182.186 10.2267 182.949 10.04 183.792 10.04C184.634 10.04 185.397 10.2267 186.08 10.6C186.762 10.9733 187.301 11.5067 187.696 12.2C188.09 12.8933 188.288 13.688 188.288 14.584C188.288 15.48 188.085 16.2747 187.68 16.968C187.274 17.6613 186.72 18.2 186.016 18.584C185.322 18.9573 184.554 19.144 183.712 19.144ZM183.712 17.56C184.181 17.56 184.618 17.448 185.024 17.224C185.44 17 185.776 16.664 186.032 16.216C186.288 15.768 186.416 15.224 186.416 14.584C186.416 13.944 186.293 13.4053 186.048 12.968C185.802 12.52 185.477 12.184 185.072 11.96C184.666 11.736 184.229 11.624 183.76 11.624C183.29 11.624 182.853 11.736 182.448 11.96C182.053 12.184 181.738 12.52 181.504 12.968C181.269 13.4053 181.152 13.944 181.152 14.584C181.152 15.5333 181.392 16.2693 181.872 16.792C182.362 17.304 182.976 17.56 183.712 17.56Z" fill="black" />
                                        <g clip-path="url(#clip0_0_1)">
                                            <path d="M20.1149 7.68642C19.9265 7.63267 19.7545 7.53266 19.6146 7.39549C19.4747 7.25831 19.3713 7.08833 19.3139 6.90101C18.9949 5.8198 18.4599 4.81456 17.7412 3.9461C17.0225 3.07765 16.135 2.36404 15.1326 1.84846C14.1301 1.33288 13.0334 1.02605 11.909 0.946539C10.7845 0.867024 9.6556 1.01648 8.59056 1.38586C7.52552 1.75524 6.54649 2.33686 5.71272 3.09553C4.87895 3.85421 4.20778 4.77415 3.73981 5.79971C3.27185 6.82526 3.01682 7.9351 2.99017 9.06206C2.96351 10.189 3.16578 11.3097 3.58474 12.3562C3.68098 12.5765 3.7017 12.8223 3.64368 13.0556C3.58565 13.2888 3.45213 13.4963 3.2639 13.6458C2.43445 14.2614 1.78687 15.0898 1.38969 16.0434C0.992504 16.9969 0.860503 18.0401 1.00765 19.0625C1.23729 20.4446 1.95487 21.6987 3.03013 22.5969C4.1054 23.4952 5.4671 23.9782 6.86807 23.9583H12.4066C12.6829 23.9583 12.9478 23.8485 13.1432 23.6532C13.3385 23.4578 13.4483 23.1929 13.4483 22.9166C13.4483 22.6404 13.3385 22.3754 13.1432 22.1801C12.9478 21.9847 12.6829 21.875 12.4066 21.875H6.86807C5.96836 21.8968 5.0906 21.5956 4.39386 21.0259C3.69713 20.4563 3.22752 19.6559 3.07015 18.7698C2.97036 18.1184 3.05124 17.4522 3.30398 16.8437C3.55672 16.2352 3.97162 15.7077 4.50349 15.3187C5.06215 14.9012 5.46628 14.3099 5.65238 13.6377C5.83847 12.9655 5.79599 12.2506 5.53161 11.6052C5.00885 10.2247 4.98197 8.7054 5.45557 7.30726C5.8339 6.21202 6.51139 5.24463 7.41128 4.51466C8.31118 3.78469 9.39752 3.32132 10.5472 3.17705C10.8139 3.14271 11.0825 3.12532 11.3514 3.12496C12.6983 3.12052 14.0105 3.5525 15.0913 4.35621C16.1722 5.15992 16.9637 6.29212 17.3472 7.5833C17.497 8.07535 17.7667 8.52243 18.1322 8.88429C18.4977 9.24615 18.9475 9.51142 19.441 9.65621C20.6488 10.0134 21.7187 10.7311 22.5073 11.7131C23.296 12.6951 23.7659 13.8947 23.854 15.1511C23.9422 16.4075 23.6444 17.6609 23.0005 18.7434C22.3567 19.8259 21.3975 20.686 20.2514 21.2083C20.0818 21.2951 19.94 21.4279 19.8422 21.5915C19.7444 21.755 19.6945 21.9428 19.6983 22.1333V22.1333C19.6962 22.3057 19.7375 22.4758 19.8184 22.628C19.8992 22.7803 20.017 22.9098 20.1609 23.0047C20.3049 23.0995 20.4703 23.1567 20.6421 23.171C20.8139 23.1853 20.9865 23.1562 21.1441 23.0864C25.4504 21.0166 27.7899 15.5718 24.1441 10.3114C23.1402 9.00196 21.7184 8.07561 20.1149 7.68642V7.68642Z" fill="#123164" />
                                            <path d="M20.4352 17.4031C20.6305 17.2078 20.7402 16.9429 20.7402 16.6667C20.7402 16.3904 20.6305 16.1255 20.4352 15.9302L18.7832 14.2781C18.1971 13.6923 17.4024 13.3632 16.5738 13.3632C15.7451 13.3632 14.9504 13.6923 14.3644 14.2781L12.7123 15.9302C12.5226 16.1267 12.4176 16.3898 12.42 16.6629C12.4223 16.936 12.5319 17.1973 12.725 17.3904C12.9182 17.5836 13.1794 17.6931 13.4525 17.6955C13.7257 17.6979 13.9888 17.5929 14.1852 17.4031L15.5321 16.0562V23.9583C15.5321 24.2346 15.6419 24.4995 15.8372 24.6949C16.0326 24.8902 16.2975 25 16.5738 25C16.85 25 17.115 24.8902 17.3103 24.6949C17.5057 24.4995 17.6154 24.2346 17.6154 23.9583V16.0562L18.9623 17.4031C19.1577 17.5984 19.4226 17.7081 19.6988 17.7081C19.975 17.7081 20.2399 17.5984 20.4352 17.4031Z" fill="#123164" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_0_1">
                                                <rect width="25" height="25" fill="white" transform="translate(0.949219)" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </label>

                                {fileUploadName

                                    ?
                                    <p>{fileUploadName}</p>
                                    :
                                    <></>
                                }

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-primary" onClick={() => handleStorage()}>Salvar</button>
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="options" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog  modal-dialog-centered modal-dialog-options " role="document">
                        <div class="modal-content">
                            <div class="modal-header" style={{ height: "55px", border: "none" }}>
                                <div className='container_header_modal_user'>
                                    <p>Ações</p>
                                    <svg data-dismiss="modal" aria-label="Close" width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.97623 6.67528L12.7796 1.66678C13.0778 1.35585 13.0778 0.851727 12.7796 0.540818C12.4815 0.229884 11.998 0.229884 11.6999 0.540818L6.897 5.54983L2.09413 0.540818C1.79597 0.229884 1.31254 0.229884 1.0144 0.540818C0.716253 0.851751 0.716229 1.35587 1.0144 1.66678L5.81777 6.67528L1.0144 11.6838C0.716229 11.9947 0.716229 12.4988 1.0144 12.8098C1.31257 13.1207 1.79599 13.1207 2.09413 12.8098L6.897 7.80072L11.6999 12.8098C11.998 13.1207 12.4815 13.1207 12.7796 12.8098C13.0778 12.4988 13.0778 11.9947 12.7796 11.6838L7.97623 6.67528Z" fill="black" />
                                    </svg>

                                </div>

                            </div>
                            <div class="modal-body" style={{ paddingRight: "0px", paddingLeft: "0px" }}>

                                <div className='container_modal_options'>
                                    {!link

                                        ?
                                        <></>
                                        :
                                        <button className='btn_secondary_modal_option_print' data-dismiss="modal" aria-label="Close" onClick={() => copyToClipboard()}  >Copiar link</button>

                                    }
                                    <button className='btn_secondary_modal_option_print' data-dismiss="modal" aria-label="Close" onClick={() => getManual()}  >Exibir manual</button>
                                    <button className='btn_secondary_modal_option_print' data-dismiss="modal" aria-label="Close" data-toggle="modal" data-target="#editManual" onClick={() => getFile()}>Editar manual</button>
                                    <button className='btn_secondary_modal_option_print' data-dismiss="modal" aria-label="Close" style={{ color: "red" }} onClick={() => handleDelete()}  >Excluir manual</button>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
                <div class="modal fade" id="optionsnoedit" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog  modal-dialog-centered modal-dialog-options " role="document">
                        <div class="modal-content">
                            <div class="modal-header" style={{ height: "55px", border: "none" }}>
                                <div className='container_header_modal_user'>
                                    <p>Ações</p>
                                    <svg data-dismiss="modal" aria-label="Close" width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.97623 6.67528L12.7796 1.66678C13.0778 1.35585 13.0778 0.851727 12.7796 0.540818C12.4815 0.229884 11.998 0.229884 11.6999 0.540818L6.897 5.54983L2.09413 0.540818C1.79597 0.229884 1.31254 0.229884 1.0144 0.540818C0.716253 0.851751 0.716229 1.35587 1.0144 1.66678L5.81777 6.67528L1.0144 11.6838C0.716229 11.9947 0.716229 12.4988 1.0144 12.8098C1.31257 13.1207 1.79599 13.1207 2.09413 12.8098L6.897 7.80072L11.6999 12.8098C11.998 13.1207 12.4815 13.1207 12.7796 12.8098C13.0778 12.4988 13.0778 11.9947 12.7796 11.6838L7.97623 6.67528Z" fill="black" />
                                    </svg>

                                </div>

                            </div>
                            <div class="modal-body" style={{ paddingRight: "0px", paddingLeft: "0px" }}>

                                <div className='container_modal_options'>
                                    {!link

                                        ?
                                        <></>
                                        :
                                        <button className='btn_secondary_modal_option_print' data-dismiss="modal" aria-label="Close" onClick={() => copyToClipboard()}  >Copiar link</button>

                                    }
                                    <button className='btn_secondary_modal_option_print' data-dismiss="modal" aria-label="Close" onClick={() => getManual()}  >Exibir manual</button>
                                    <button className='btn_secondary_modal_option_print' data-dismiss="modal" aria-label="Close" style={{ color: "red" }} onClick={() => handleDelete()}  >Excluir manual</button>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
                <div class="modal fade" id="addMultiple" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLongTitle">Adicionar quantidade</h5>
                            </div>
                            <div class="modal-body">

                                <p className='textPrimaryModalFile'>Informe quantas etiquetas deseja imprimir</p>
                                {uris?.map(item => {
                                    console.log(item)
                                    return (
                                        <div>
                                            <img src={item.image} style={{ width: "50px", height: "50px", objectFit: "contain" }} />
                                            <span className='textSkuUri'>{item.sku}</span>
                                            <span className='textSkuUri'>{item.name}</span>

                                            <Input name={`Quantidade *`} type={"tel"} placeholder={"máximo 1000 itens"} mask={"9999"} onChange={(e) => handleQtdChange(item.uri, e.target.value)} />
                                        </div>
                                    )
                                })}

                            </div>
                            <div class="modal-footer">
                                {stateBtn == false

                                    ?
                                    <></>
                                    :
                                    <button type="button" class="btn btn-primary" onClick={() => { printMultipleQrCodes() }}>Salvar</button>
                                }
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="addQtdKit" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLongTitle">Adicionar quantidade</h5>
                            </div>
                            <div class="modal-body">

                                <p className='textPrimaryModalFile'>Informe a quantidade para o componente <b>{selectComponent}</b></p>

                                <Input name={`Quantidade *`} onChange={(e) => setQtdComponent(e.target.value)} type={"tel"} mask={"9999"} />


                            </div>
                            <div class="modal-footer">
                                {stateBtn == false

                                    ?
                                    <></>
                                    :
                                    <button type="button" class="btn btn-primary" data-dismiss="modal" onClick={() => { handleComponent(selectComponent, qtdComponent) }}>Salvar</button>
                                }
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="addEditQtdKit" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLongTitle">Adicionar quantidade</h5>
                            </div>
                            <div class="modal-body">

                                <p className='textPrimaryModalFile'>Informe a quantidade para o componente <b>{selectComponent}</b></p>

                                <Input name={`Quantidade *`} onChange={(e) => setQtdComponent(e.target.value)} type={"tel"} mask={"9999"} />


                            </div>
                            <div class="modal-footer">
                                {stateBtn == false

                                    ?
                                    <></>
                                    :
                                    <button type="button" class="btn btn-primary" data-dismiss="modal" onClick={() => { handleEditComponent(selectComponent, qtdComponent) }}>Salvar</button>
                                }
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="addPersonalizateFile" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLongTitle">Adicionar arquivo</h5>
                            </div>
                            <div class="modal-body">

                                <p className='textPrimaryModalFile'>preencha as informações <b>abaixo:</b></p>
                                <Input type={"text"} name={"SKU*"} onChange={(e) => setPersonalizateSku(e.target.value)} />
                                <Input type={"text"} placeholder={"Ex: Revisão 2025"} name={"Revisão*"} onChange={(e) => setPersonalizateRevision(e.target.value)} />

                                <Input type={"file"} name={"Arquivo"} onChange={(e) => setPersonalizateFile(e.target.files[0])} />
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-primary" onClick={() => handlePersonalizateFile()}>{animation == true ? "Processando..." : "Confirmar"}</button>

                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">

                    <div id='qr-codes-generate' ref={contentRef}>
                    </div>
                </div>



            </section>
            {userSelectFiles.length > 0

                ?
                <Footer />

                :
                <></>
            }

        </>


    )
}

export default Files